<template>
  <div class="my-setting-container">
    <el-form ref="form" :model="form" label-width="150px">
      <el-form-item label="过期文件提醒">
        <el-select v-model="form.day" placeholder="请选择天数" width="100%">
          <el-option v-for="option in dayOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { myFilesApi } from '@/api/index';
export default {
  name: 'my-setting-container',
  data () {
    return {
      form: {
        day: 30
      },
      dayOptions: [
        { label: '提前30天提醒', value: 30 },
        { label: '提前90天提醒', value: 90 },
        { label: '提前180天提醒', value: 180 },
        { label: '提前360天提醒', value: 360 },
        { label: '提前720天提醒', value: 720 },
        { label: '提前1080天提醒', value: 1080 },
      ]
    }
  },
  mounted () {
    this.getMySetting();
  },
  methods: {
    close () {
      this.$emit('close');
    },
    // 获取我的设置
    async getMySetting () {
      const res = await myFilesApi.getMySetting();
      if (res.code === 200) {
        this.form.day = res.data.day
      }
    },
    // 保存设置
    async save () {
      const res = await myFilesApi.addMySetting(this.form);
      if (res.code === 200) {
        this.$message.success(res.message);
        await this.$store.dispatch('user/getMySetting');
        this.close();
      } else {
        this.$message.error(res.message);
      }
    }
  }
}
</script>

<style>
</style>